import { providesList } from '@helpers/index';
import BaseService from '../base';
import { ScheduleApiProps } from './types';

class Schedule extends BaseService {
  deleteSchedule() {
    return {
      query: (id: number) => ({
        url: `${this.url}/${id}`,
        method: 'delete',
      }),
      invalidatesTags: [{ type: this.tagType, id: 'LIST' }],
    };
  }

  getSiteSchedules() {
    return {
      query: (id: number) => ({
        url: `sites/${id}/schedules`,
      }),
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      providesTags: (result: ScheduleApiProps[] | undefined) => (
        providesList(result, this.tagType)),
    };
  }

  // eslint-disable-next-line class-methods-use-this
  downloadSiteReport() {
    return {
      queryFn: async (
        id: number,
        _api: unknown,
        _extraOptions: unknown,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        fetchWithBQ: any,
      ) => {
        const result = await fetchWithBQ({
          url: `/site-reports/${id}/download`,
          method: 'GET',
          responseHandler: async (response: Response) => {
            const blob = await response.blob();
            const disposition = response.headers.get('content-disposition');
            const filename = disposition?.split(';')[1].replace(/.*filename="(.+)"/, '$1');
            return { blob, filename };
          },
        });

        if (result.error) {
          return { error: result.error };
        }

        return { data: result.data };
      },
    };
  }
}

export default new Schedule('schedules', 'Schedule');
